var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h1',[_vm._v(" 负载均衡")]),_c('iframe',{staticStyle:{"width":"100%","height":"90vh"},attrs:{"id":"myiframe","src":_vm.iframeUrl,"scrolling":"no","frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }